var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-skeleton-loader',{staticClass:"tw-rounded-full tw--ml-1 sm:tw-ml-1",attrs:{"type":"image","width":"32","height":"32"}}):_c('v-btn',{staticClass:"sm:tw--ml-1",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('toggleDrawer')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiMenu))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }